import { reduce } from 'lodash';
import {
  fetchManufacturers,
  fetchManufacturerModels,
} from '../../api/claimApi';

const GET_CAR_MANUFACTURERS = 'efes/CmtplForm/GET_CAR_MANUFACTURERS';
const GET_CAR_MANUFACTURERS_SUCCESS = 'efes/CmtplForm/GET_CAR_MANUFACTURERS_SUCCESS';
const GET_CAR_MANUFACTURERS_FAIL = 'efes/CmtplForm/GET_CAR_MANUFACTURERS_FAIL';

const GET_CAR_MANUFACTURER_MODELS = 'efes/CmtplForm/GET_CAR_MANUFACTURER_MODELS';
const GET_CAR_MANUFACTURER_MODELS_SUCCESS = 'efes/CmtplForm/GET_CAR_MANUFACTURER_MODELS_SUCCESS';
const GET_CAR_MANUFACTURER_MODELS_FAIL = 'efes/CmtplForm/GET_CAR_MANUFACTURER_MODELS_FAIL';

const GET_PERSONAL_CLAIM_MODELS = 'efes/CmtplForm/GET_PERSONAL_CLAIM_MODELS';
const GET_PERSONAL_CLAIM_MODELS_SUCCESS = 'efes/CmtplForm/GET_PERSONAL_CLAIM_MODELS_SUCCESS';
const GET_PERSONAL_CLAIM_MODELS_FAIL = 'efes/CmtplForm/GET__PERSONAL_CLAIM_MODELS_FAIL';

const initialState = {
  manufacturers: [],
  isManufacturersLoading: false,
  manufacturersError: null,
  manufacurerModels: [],
  isManufacturerModelsLoading: false,
  manufacturerModelsError: null,
  personalClaimModels: {},
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_CAR_MANUFACTURERS:
      return {
        ...state,
        manufacturers: [],
        isManufacturersLoading: true,
      };
    case GET_CAR_MANUFACTURERS_SUCCESS:
      return {
        ...state,
        isManufacturersLoading: false,
        manufacturers: action.result.transportManufacturers,
      };
    case GET_CAR_MANUFACTURERS_FAIL:
      return {
        ...state,
        isManufacturersLoading: false,
        manufacturersError: action.error,
      };

    case GET_CAR_MANUFACTURER_MODELS:
      return {
        ...state,
        manufacurerModels: [],
        isManufacturerModelsLoading: true,
      };
    case GET_CAR_MANUFACTURER_MODELS_SUCCESS:
      return {
        ...state,
        isManufacturerModelsLoading: false,
        manufacurerModels: action.result.transportModels,
      };
    case GET_CAR_MANUFACTURER_MODELS_FAIL:
      return {
        ...state,
        isManufacturerModelsLoading: false,
        manufacturerModelsError: action.error,
      };

    case GET_PERSONAL_CLAIM_MODELS:
      return {
        ...state,
        personalClaimModels: {
          ...state.personalClaimModels,
          loadingModels: action.loadingModels,
        },
      };
    case GET_PERSONAL_CLAIM_MODELS_SUCCESS:
      return {
        ...state,
        personalClaimModels: {
          ...state.personalClaimModels,
          loadingModels: [],
          ...action.result.models,
        },
      };
    case GET_PERSONAL_CLAIM_MODELS_FAIL:
      return {
        ...state,
        personalClaimModels: {
          loadingModels: [],
          error: action.error,
        },
      };

    default:
      return state;
  }
}

export function getCarManufacturers() {
  return {
    actions: [
      { type: GET_CAR_MANUFACTURERS },
      { type: GET_CAR_MANUFACTURERS_SUCCESS },
      { type: GET_CAR_MANUFACTURERS_FAIL },
    ],
    promise: fetchManufacturers(),
  };
}

export function getCarManufacturerModels(mId) {
  return {
    actions: [
      { type: GET_CAR_MANUFACTURER_MODELS },
      { type: GET_CAR_MANUFACTURER_MODELS_SUCCESS },
      { type: GET_CAR_MANUFACTURER_MODELS_FAIL },
    ],
    promise: fetchManufacturerModels(mId),
  };
}

export function getPersonalClaimModels(mIds) {
  const modelsRequests = mIds.map((mId) => fetchManufacturerModels(mId));

  return {
    actions: [
      { type: GET_PERSONAL_CLAIM_MODELS },
      { type: GET_PERSONAL_CLAIM_MODELS_SUCCESS },
      { type: GET_PERSONAL_CLAIM_MODELS_FAIL },
    ],
    promise: Promise.all(modelsRequests).then((responses) => {
      const models = reduce(
        responses,
        (result, { transportModels }) => {
          const key = transportModels[0].manufacturer;
          result[key] = transportModels; // eslint-disable-line no-param-reassign
          return result;
        },
        {},
      );

      return { models };
    }),
    loadingModels: mIds,
  };
}
